define([
    "jquery",
    "underscore",
    "marionette",
    "views/common/datatables_view",
    "bootstrap.datepicker",
    "datatables"
], function($, _, Marionette) {
    let datatable;
    return Marionette.View.extend({
        el: '#content_layout',

        behaviors: {

        },

        ui: {
            'clientsInPeriod': '#clients-in-period',
            'totalCommission': '#total-commission',
            'search': '#search-btn',
            'selectedAccount': '#selected_account',
            'startDate': '#search-start-date',
            'startDateInput': '#search-start-date-input',
            'endDate': '#search-end-date',
            'endDateInput': '#search-end-date-input',
            'datatables': '#datatables',
        },

        events: {
            'click @ui.search': 'draw_datatable',
        },

        initialize: function() {
            this.bindUIElements();
            this.initDatetimePickers();
            this.initDatatable();
        },

        initDatetimePickers: function() {
            this.ui.startDate.datetimepicker({
                format: 'YYYY-MM-DD'
            });
            this.ui.endDate.datetimepicker({
                format: 'YYYY-MM-DD'
            });
        },

        initDatatable: function() {
            let columns =[
                {
                    'name':'child_account',
                    'data':'child_account',
                },
                {
                    'name':'name',
                    'data':'name'
                },
                {
                    'name':'country',
                    'data':'country'
                },
                {
                    'name':'volume',
                    'data':'volume',
                },
                {
                    'name':'commission',
                    'data':'commission',
                }
            ];

            let that= this;
            datatable = this.ui.datatables.DataTable({
                'searching': false,
                'ordering': true,
                'stateSave': false,
                'columns': columns,
                'deferRender': true,
                'serverSide': true,
                'pageLength': 10, // nbPerPage,
                'processing': true,
                'ajax': {
                    type: "POST",
                    url: baseUrl + '/rest_fee/partner_commissions',
                    data: function (data) {
                        data.filters = {
                            selected_account: that.ui.selectedAccount.val(),
                            start_date: that.ui.startDateInput.val(),
                            end_date: that.ui.endDateInput.val()
                        }
                    },
                    dataSrc: function(data) {
                        $(that.ui.clientsInPeriod).html(data['recordsTotal']);
                        $(that.ui.totalCommission).html(data['totalCommission']);
                        return data.data;
                    }
                },
                language:{
                    url: baseUrl+'/assets/common/common/js/libs/DataTables/languages/'+lang+'.json'
                }
            });
        },

        draw_datatable: function() {
            if (datatable) {
                datatable.draw();
            }
        },
    })
})